(function() {
  var style = document.createElement('style');
  style.textContent = [
    '.block-swatch { position: relative !important; overflow: visible !important; }',
    '.bvt-deal-badge {',
    '  position: absolute;',
    '  top: -9px;',
    '  right: -9px;',
    '  background: #dc2626;',
    '  color: #fff;',
    '  font-size: 9px;',
    '  font-weight: 700;',
    '  letter-spacing: 0.6px;',
    '  padding: 2px 6px;',
    '  border-radius: 10px;',
    '  line-height: 1.4;',
    '  text-transform: uppercase;',
    '  pointer-events: none;',
    '  white-space: nowrap;',
    '  z-index: 2;',
    '  font-family: sans-serif;',
    '}'
  ].join('');
  document.head.appendChild(style);

  function addBadges() {
    var swatches = document.querySelectorAll('label.block-swatch, .block-swatch');
    swatches.forEach(function(swatch) {
      if (swatch.querySelector('.bvt-deal-badge')) return;
      var text = swatch.textContent.trim();
      if (/^\d+\s*x\s/i.test(text)) {
        var badge = document.createElement('span');
        badge.className = 'bvt-deal-badge';
        badge.textContent = 'Multi-box Deal';
        swatch.appendChild(badge);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBadges);
  } else {
    addBadges();
  }

  var observer = new MutationObserver(function(mutations) {
    if (mutations.some(function(m) { return m.addedNodes.length > 0; })) addBadges();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
